var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"label-data-title"},[_c('span',{staticClass:"label-data-title-label"},[_vm._v(_vm._s(_vm.label)+": ")]),_vm._v(" "),(_vm.data)?_c('span',{staticClass:"label-data-title-data"},[_vm._v(_vm._s(_vm.data))]):_vm._e()])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }